import { reduce } from 'lodash';
import { RootState } from '../redux';

export const selectFilterSelectedSize = (state: RootState) =>
  reduce(state.filter.selected, (result, values) => result + values.length, 0);
